import axios from "../../adminCompenents/config/axiosConfig";

export default class ImageCategoryService {
  // 🔹 Récupérer toutes les images de catégorie
  getAll = async () => {
    try {
      const response = await axios.get("/image-category");
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération des images de catégorie : " +
          error.message
      );
    }
  };

  // 🔹 Créer une nouvelle image de catégorie
  create = async (formData) => {
    try {
      const response = await axios.post("/image-category", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la création de l'image de catégorie : " + error.message
      );
    }
  };

  // 🔹 Modifier une image de catégorie existante
  update = async (id, formData) => {
    try {
      const response = await axios.put(`/image-category/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la modification de l'image de catégorie : " +
          error.message
      );
    }
  };

  // 🔹 Supprimer une image de catégorie
  delete = async (id) => {
    try {
      const response = await axios.delete(`/image-category/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la suppression de l'image de catégorie : " +
          error.message
      );
    }
  };

  // 🔹 Récupérer une image de catégorie par son ID
  getById = async (id) => {
    try {
      const response = await axios.get(`/image-category/${id}`);
      return response;
    } catch (error) {
      throw new Error(
        "Erreur lors de la récupération de l'image de catégorie : " +
          error.message
      );
    }
  };
}
